"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
exports.__esModule = true;
exports.getNftCapabilities = exports.isNFTActive = exports.isNftTransaction = void 0;
var env_1 = require("../env");
var isNftTransaction = function (transaction) {
    if (transaction.family === "ethereum") {
        return ["erc721.transfer", "erc1155.transfer"].includes(transaction.mode);
    }
    return false;
};
exports.isNftTransaction = isNftTransaction;
function isNFTActive(currency) {
    return (0, env_1.getEnv)("NFT_CURRENCIES").split(",").includes(currency.id);
}
exports.isNFTActive = isNFTActive;
var nftCapabilities = {
    hasQuantity: ["ERC1155"]
};
var getNftCapabilities = function (nft) {
    return Object.entries(nftCapabilities).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), capability = _c[0], standards = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[capability] = standards.includes(nft.standard), _b)));
    }, {});
};
exports.getNftCapabilities = getNftCapabilities;
//# sourceMappingURL=support.js.map